import { AuthGuard } from '@/components/auth/auth-guard';
import { AppLayout } from '@/components/layout';
import { AbsencesPageHeader } from '@/features/absences/components/absences-page-header';
import { BalancesOverviewView } from '@/features/absences/components/balances/balances-overview-view';
import { useAuthStore } from '@/stores/auth';
import { hasPlaceholderPermission, usePermission } from '@/lib/permissions';
import { Navigate, createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/absences/balances')({
  beforeLoad: async () => {
    const { isAuthenticated, isInitialized } = useAuthStore.getState();
    if (!isInitialized) return;
    if (!isAuthenticated) throw redirect({ to: '/login' });

    const user = useAuthStore.getState().user;
    if (hasPlaceholderPermission(user)) throw redirect({ to: '/placeholder' });
  },
  component: AbsencesBalancesPage,
});

function AbsencesBalancesPage() {
  const canView = usePermission('absences.balances.view');
  if (!canView) {
    return <Navigate to="/absences/calendar" replace />;
  }
  return (
    <AuthGuard>
      <AppLayout>
        <AbsencesPageHeader />
        <div className="min-h-full animate-fade-in">
          <BalancesOverviewView />
        </div>
      </AppLayout>
    </AuthGuard>
  );
}
